import { post, get, deletefn, putfun } from './http.js'
export default {
  // 素材列表分类
  async materialCategoriesList (params) {
    return await get ('/material-categories',params)
  },
  // 素材列表
  async materialList (params) {
    return await get ('/materials',params)
  },
  // 发布素材
  async materialRelease (data) {
    return await post ('/materials',data)
  },
  // 素材更新
  async materialUpdate(params) {
    return await putfun (`/materials/${params.id}`,params)
  },
  // 素材详情
  async materialDetail (params) {
    return await get (`/materials/${params}`)
  },
  // 删除
  async materialDelete (data) {
    return await deletefn (`/materials/${data}`)
  },
  // 评论
  async materialComment (data) {
    return await post (`/materials-reply/${data.id}`,data)
  },
  // 删除自己评论
  async deleteReply (data) {
    return await deletefn (`/materials-reply/${data}`)
  },
  // 回复列表
  async commentList (data) {
    return await get (`/materials-reply/${data.id}`,data)
  },
  // 素材格式
  async formatList (data) {
    return await get (`/file-format`)
  },
  // 素材下载
  async materialDownload (data) {
    return await post (`/common/materials-download/${data}`)
  },
  // 素材列表评分
  async materialScore (params) {
    return await get ('/common/rate',params)
  },
  // 素材评价
  async materialRate (params) {
    return await post ('/common/rate',params)
  },
}



// WEBPACK FOOTER //
// ./src/request/material.js